/* @flow */

import * as types from 'src/shared/app/signup/action/signupActionTypes';
import {
  signupActivationForm,
  signupEmailForm,
  signupPasswordForm,
  signupAboutForm,
  signupAvatarForm,
} from 'src/shared/app/signup/constant/signupConstants';
import { createReducer } from 'src/shared/core/util/reducerUtils';

/*
|------------------------------------------------------------------------------
| INITIAL STATE
|------------------------------------------------------------------------------
*/

const initialState = {
  form: signupActivationForm,
  isIncomplete: false,
};

/*
|------------------------------------------------------------------------------
| REDUCERS
|------------------------------------------------------------------------------
*/

const _showEmailForm = (state: Object): Object => ({
  ...state,
  form: signupEmailForm,
});

const _showPasswordForm = (state: Object): Object => ({
  ...state,
  form: signupPasswordForm,
});

const _showAboutForm = (state: Object): Object => ({
  ...state,
  form: signupAboutForm,
});

const _showAvatarForm = (state: Object): Object => ({
  ...state,
  form: signupAvatarForm,
});

const _markAsComplete = (state: Object): Object => ({
  ...state,
  isIncomplete: false,
});

const _markAsIncomplete = (state: Object): Object => ({
  ...state,
  isIncomplete: true,
});

/*
|------------------------------------------------------------------------------
| REDUCER
|------------------------------------------------------------------------------
*/

export default createReducer(initialState, {
  [types.SHOW_SIGNUP_EMAIL_FORM]: _showEmailForm,
  [types.SHOW_SIGNUP_PASSWORD_FORM]: _showPasswordForm,
  [types.SHOW_SIGNUP_ABOUT_FORM]: _showAboutForm,
  [types.SHOW_SIGNUP_AVATAR_FORM]: _showAvatarForm,
  [types.MARK_SIGNUP_AS_COMPLETE]: _markAsComplete,
  [types.MARK_SIGNUP_AS_INCOMPLETE]: _markAsIncomplete,
});
